import { render, staticRenderFns } from "./HeaderCandidats.vue?vue&type=template&id=4cc3226e"
import script from "./HeaderCandidats.vue?vue&type=script&lang=js"
export * from "./HeaderCandidats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CampusDropDownMenuHeader: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/CampusDropDownMenuHeader.vue').default})
